module.exports = __webpack_public_path__ + "media/images/athletes/3549-193ad1c7110cbd55d9e22f0f46d251af.png";